import { render, staticRenderFns } from "./ReplacementZJList.vue?vue&type=template&id=216dfbaa&scoped=true"
import script from "./ReplacementZJList.vue?vue&type=script&lang=js"
export * from "./ReplacementZJList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216dfbaa",
  null
  
)

export default component.exports